"use client";

import {
  ADXConfig,
  BollingerBandsConfig,
  EnvelopesConfig,
  IchimokuConfig,
  MovingAverageConfig,
  ParabolicSARConfig,
  StandardDeviationConfig,
} from "./indicators/trend";
import {
  MACDConfig,
  ATRConfig,
  BearsPowerConfig,
  BullsPowerConfig,
  CCIConfig,
  DeMarkerConfig,
  ForceIndexConfig,
  MomentumConfig,
  OsMAConfig,
  RSIConfig,
  RVIConfig,
  StochasticConfig,
  WPRConfig,
} from "./indicators/oscillators";
import {
  ADConfig,
  MFIConfig,
  OBVConfig,
  VolumesConfig,
} from "./indicators/volumes";
import {
  ACConfig,
  AlligatorConfig,
  AOConfig,
  FractalsConfig,
  GatorConfig,
  MFIBWConfig,
} from "./indicators/bill-williams";
import BaseIndicatorConfig from "./indicators/common/BaseIndicatorConfig";

interface IndicatorConfigFactoryProps {
  indicator: any;
  onBack: () => void;
  onApply: any;
  isEditing?: boolean;
}

export default function IndicatorConfigFactory({
  indicator,
  onBack,
  onApply,
  isEditing,
}: IndicatorConfigFactoryProps) {
  switch (indicator.indicatorId) {
    case "adx":
      return (
        <ADXConfig indicator={indicator} onBack={onBack} onApply={onApply}
          isEditing={isEditing} />
      );
    case "bollinger-bands":
      return (
        <BollingerBandsConfig
          indicator={indicator}
          onBack={onBack}
          onApply={onApply}
          isEditing={isEditing}
        />
      );
    case "envelopes":
      return (
        <EnvelopesConfig
          indicator={indicator}
          onBack={onBack}
          onApply={onApply}
          isEditing={isEditing}
        />
      );
    case "ichimoku":
      return (
        <IchimokuConfig
          indicator={indicator}
          onBack={onBack}
          onApply={onApply}
          isEditing={isEditing}
        />
      );
    case "ma":
      return (
        <MovingAverageConfig
          indicator={indicator}
          onBack={onBack}
          onApply={onApply}
          isEditing={isEditing}
        />
      );
    case "parabolic-sar":
      return (
        <ParabolicSARConfig
          indicator={indicator}
          onBack={onBack}
          onApply={onApply}
          isEditing={isEditing}
        />
      );
    case "std-dev":
      return (
        <StandardDeviationConfig
          indicator={indicator}
          onBack={onBack}
          onApply={onApply}
          isEditing={isEditing}
        />
      );
    case "macd":
      return (
        <MACDConfig indicator={indicator} onBack={onBack} onApply={onApply}
          isEditing={isEditing} />
      );
    case "atr":
      return (
        <ATRConfig indicator={indicator} onBack={onBack} onApply={onApply}
          isEditing={isEditing} />
      );
    case "bears-power":
      return (
        <BearsPowerConfig
          indicator={indicator}
          onBack={onBack}
          onApply={onApply}
          isEditing={isEditing}
        />
      );
    case "bulls-power":
      return (
        <BullsPowerConfig
          indicator={indicator}
          onBack={onBack}
          onApply={onApply}
          isEditing={isEditing}
        />
      );
    case "cci":
      return (
        <CCIConfig indicator={indicator} onBack={onBack} onApply={onApply}
          isEditing={isEditing} />
      );
    case "demarker":
      return (
        <DeMarkerConfig
          indicator={indicator}
          onBack={onBack}
          onApply={onApply}
          isEditing={isEditing}
        />
      );
    case "force-index":
      return (
        <ForceIndexConfig
          indicator={indicator}
          onBack={onBack}
          onApply={onApply}
          isEditing={isEditing}
        />
      );
    case "momentum":
      return (
        <MomentumConfig
          indicator={indicator}
          onBack={onBack}
          onApply={onApply}
          isEditing={isEditing}
        />
      );
    case "osma":
      return (
        <OsMAConfig indicator={indicator} onBack={onBack} onApply={onApply}
          isEditing={isEditing} />
      );
    case "rsi":
      return (
        <RSIConfig indicator={indicator} onBack={onBack} onApply={onApply}
          isEditing={isEditing} />
      );
    case "rvi":
      return (
        <RVIConfig indicator={indicator} onBack={onBack} onApply={onApply}
          isEditing={isEditing} />
      );
    case "stochastic":
      return (
        <StochasticConfig
          indicator={indicator}
          onBack={onBack}
          onApply={onApply}
          isEditing={isEditing}
        />
      );
    case "wpr":
      return (
        <WPRConfig indicator={indicator} onBack={onBack} onApply={onApply}
          isEditing={isEditing} />
      );
    case "ad":
      return (
        <ADConfig indicator={indicator} onBack={onBack} onApply={onApply}
          isEditing={isEditing} />
      );
    case "mfi":
      return (
        <MFIConfig indicator={indicator} onBack={onBack} onApply={onApply}
          isEditing={isEditing} />
      );
    case "obv":
      return (
        <OBVConfig indicator={indicator} onBack={onBack} onApply={onApply}
          isEditing={isEditing} />
      );
    case "volumes":
      return (
        <VolumesConfig
          indicator={indicator}
          onBack={onBack}
          onApply={onApply}
          isEditing={isEditing}
        />
      );
    case "ac":
      return (
        <ACConfig indicator={indicator} onBack={onBack} onApply={onApply}
          isEditing={isEditing} />
      );
    case "alligator":
      return (
        <AlligatorConfig
          indicator={indicator}
          onBack={onBack}
          onApply={onApply}
          isEditing={isEditing}
        />
      );
    case "ao":
      return (
        <AOConfig indicator={indicator} onBack={onBack} onApply={onApply}
          isEditing={isEditing} />
      );
    case "fractals":
      return (
        <FractalsConfig
          indicator={indicator}
          onBack={onBack}
          onApply={onApply}
          isEditing={isEditing}
        />
      );
    case "gator":
      return (
        <GatorConfig indicator={indicator} onBack={onBack} onApply={onApply}
          isEditing={isEditing} />
      );
    case "mfi-bw":
      return (
        <MFIBWConfig indicator={indicator} onBack={onBack} onApply={onApply}
          isEditing={isEditing} />
      );
    default:
      return (
        <BaseIndicatorConfig
          indicator={indicator}
          onBack={onBack}
          onApply={onApply}
          isEditing={isEditing}
          defaultExpandedStyle="main"
        />
      );
  }
}
